// @/router/index.js

import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../App.vue";

const routes = [
{
path: "/",
name: "home",
component: HomeView,
},
{
path: "/project",
name: "project",
component: () => import("../ProjectPage.vue"),
},
];

const router = createRouter({
history: createWebHistory(process.env.BASE_URL),
routes,
});

export default router;